import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { AppFacadeService } from '../../services/app-facade.service';
import { ContractCP } from '../../models/contract-model';
import { Subscription } from 'rxjs';
import { MULTI_CONTRACT_MAX_SELECTION_ALLOWED } from '../../constants/default.const';

@Component({
    standalone: false,
    selector: 'por-multi-payment-contract-panel',
    templateUrl: './multi-payment-contract-panel.component.html',
    styleUrls: ['./multi-payment-contract-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiPaymentContractPanelComponent implements OnInit, OnDestroy {
    readonly appFacadeService = inject(AppFacadeService);

    @Input() isOpen = false; // Overlay open/close state
    @Input() trigger!: CdkOverlayOrigin; // Overlay trigger passed from parent
    @Output() readonly closeOverlay = new EventEmitter<void>(); // Emit event to parent when closing

    private readonly subscriptions: Subscription[] = [];
    total = 0;
    selectedContract = 0;

    // Expose constant to template for translation parameter
    readonly maxContractsAllowed = MULTI_CONTRACT_MAX_SELECTION_ALLOWED;

    ngOnInit(): void {
        this.subscriptions.push(
            this.appFacadeService.getContractsTotal().subscribe(total => {
                this.total = total;
            }),
            this.appFacadeService.getSelectedContracts().subscribe(contracts => {
                this.selectedContract = contracts.length;
            })
        );
    }

    closeOverlayClick(): void {
        this.closeOverlay.emit();
    }

    removeContracts(contract: ContractCP | ContractCP[]) {
        const contractIds: string[] = Array.isArray(contract)
            ? contract.map(c => c.contractId) // If multiple contracts, get their IDs
            : [contract.contractId]; // If single contract, create an array with its ID
        this.appFacadeService.unsetSelectedContracts(contractIds);
        // If no contract is selected then close the modal
        if (!this.selectedContract) {
            this.closeOverlay.emit();
        }
    }

    onClickContinue(): void {
        if (this.total >= 1) {
            this.closeOverlay.emit();
            this.appFacadeService.multiPaymentContinue();
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
